import React from 'react';

import Logo from '../../Logo/Logo';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';
import {
  Header,
  LogoNavSearchContainer,
  LogoHolder
} from '../../StyledComponents/HeaderElements';
import ShareLinks from '../../ShareLinks/ShareLinks';

const StickyHeader = props => {
  // console.log('e: ', e);
  // e.stopPropagation();
  return (
    <Header className="StickyHeader justify-center" style={{ zIndex: '89' }}>
      <DrawerToggle
        className="DrawerToggle"
        clicked={props.drawerToggleClicked}
      />
      <LogoNavSearchContainer
        className="Logo-Nav-App-Search"
        style={{ maxWidth: '1440px' }}
      >
        <LogoHolder className="LogoHolder">
          <Logo className="Logo">
            <ShareLinks />
          </Logo>
        </LogoHolder>
      </LogoNavSearchContainer>
    </Header>
  );
};

export default StickyHeader;
